export default "__VITE_ASSET__e31d34db__"